class XAddMultipleProducts extends XThemeBaseElement {
  constructor() {
    super()
    this._onFormSubmit = this._onFormSubmit.bind(this)
  }
  mount() {
    /** @type {HTMLFormElement} */
    const form = document.createElement('form')
    this._form = form

    const mainProductFormId = this.getAttribute('data-product-form-id')
    const mainProductForm = mainProductFormId ? document.getElementById(mainProductFormId) : null
    this.mainProductForm = mainProductForm

    const formId = `form_addons_${Math.random().toString(36).slice(2)}`
    form.setAttribute('id', formId)
    form.addEventListener('submit', this._onFormSubmit, {
      signal: this._ac.signal,
    })
    document.body.appendChild(form)
    this.setAttribute('data-form-id', formId)

    const formElements = Array.from(
      this.querySelectorAll('[data-form-input], button[type="submit"')
    )
    for (let i = 0, l = formElements.length; i < l; i++) {
      const el = formElements[i]
      el.setAttribute('form', formId)
    }
  }

  /**
   *
   * @param {SubmitEvent} e
   */
  async _onFormSubmit(e) {
    e.preventDefault()
    e.stopPropagation()

    if (!this.mainProductForm.checkValidity()) {
      this.mainProductForm.reportValidity()
      return
    }

    if (!this._form.checkValidity()) {
      this._form.reportValidity()
      return
    }

    const items = []

    // generate 8 char random string
    const randomBundleId = Math.random().toString(36).slice(2, 10) + '_' + Date.now()
    const mainProductFd = new FormData(this.mainProductForm)
    const props = { _bundle_id: randomBundleId }
    mainProductFd.forEach((value, key) => {
      if (key.startsWith('properties[')) {
        props[key] = value
      }
    })
    const mainProductJson = {
      id: +mainProductFd.get('id'),
      quantity: +mainProductFd.get('quantity') || 1,
      properties: props,
    }
    items.push(mainProductJson)

    const form = this._form
    const fd = new FormData(form)

    const iterator = fd.entries()
    let entry
    let i = 0

    // we assume that `quantity` input appear AFTER the variant input in the DOM. always!!
    while (!(entry = iterator.next()).done) {
      const [key, value] = entry.value

      if (key.startsWith('variant.id')) {
        entry = iterator.next()
        const [qtyKey, qtyValue] = entry.value
        // console.log({ varaint: value, qty: +qtyValue });
        const variantJson = {
          id: +value,
          quantity: +qtyValue,
          properties: {
            _parent_bundle_id: randomBundleId,
          },
        }
        items.push(variantJson)
      }

      i++
    }

    // const json = [...fd.entries()].map(([k, v]) => ({ [k]: v }));
    // fd.forEach((value, key) => {
    //   if (key.startsWith('variant.id')) {
    //     const qty = +fd.get(key.replace('variant.id', 'variant.qty'))
    //     if (qty > 0) {
    //       const variantJson = {
    //         id: +value,
    //         quantity: qty,
    //         properties: {
    //           _parent_bundle_id: randomBundleId,
    //         },
    //       }
    //       items.push(variantJson)
    //     }
    //   }
    // })

    console.log(items)

    document.dispatchEvent(new CustomEvent('theme:loading:start'))
    this.setAttribute('data-status', 'pending')
    return fetch(`/cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.reverse() }),
    })
      .then((r) => r.json())
      .then(() => {
        this.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: null, button: null, quantity: 0 },
          })
        )
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('theme:loading:end'))
        }, 800)
        this.setAttribute('data-status', 'idle success')
      })
  }

  unmount() {
    const form = this._form
    if (form) {
      form.remove()
    }
    this._form = null
  }
}

if (!customElements.get('x-add-multiple-products')) {
  customElements.define('x-add-multiple-products', XAddMultipleProducts)
}

class XProductItem extends XThemeBaseElement {
  constructor() {
    super()

    /**
     * @type {{
     *  addonParent: XAddMultipleProducts,
     *  field_vid: HTMLSelectElement,
     *  field_qty: HTMLInputElement,
     *  featured_img: HTMLImageElement | null,
     *  prices: {
     *    current: HTMLSpanElement,
     *    compare: HTMLSpanElement,
     *    total: HTMLSpanElement,
     *  },
     *  duplicate_btn: HTMLButtonElement | null,
     * }}
     */
    this._totalClones = 0
    this._variantIds = []
    this._featured_img_src = ''

    this.els = {
      addonParent: /** @type {any} */ (null),
      field_vid: /** @type {any} */ (null),
      field_qty: /** @type {any} */ (null),
      featured_img: /** @type {any} */ (null),
      prices: {
        current: /** @type {any} */ (null),
        compare: /** @type {any} */ (null),
        total: /** @type {any} */ (null),
      },
      duplicate_btn: /** @type {any} */ (null),
    }
  }

  mount() {
    this._cacheElements()

    this.addEventListener(
      'change',
      (e) => {
        e.stopPropagation()

        const target = e.target
        const name = target.getAttribute('data-form-input')
        const variantChanged = name === 'variant.id'

        // listen for variant id change
        if (variantChanged) {
          this._onVariantChange(e)
          return
        }
      },
      { signal: this._ac.signal }
    )

    this.addEventListener(
      'input',
      (e) => {
        e.stopPropagation()

        const target = e.target
        const name = target.getAttribute('data-form-input')
        const quantityChanged = name === 'variant.qty'

        // listen for quantity change
        if (quantityChanged) {
          this._onQuantityChange(e)
          return
        }
      },
      { signal: this._ac.signal }
    )

    if (this.els.duplicate_btn) {
      this.els.duplicate_btn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        
        if ((this._totalClones + 1) === this._variantIds.length) {
          return
        }

        this._totalClones++
        const clone = this.cloneNode(true)
        /** @type {HTMLElement} */
        let insertAfter = this
        while (insertAfter.nextElementSibling?.getAttribute('data-duplicate') === 'true') {
          insertAfter = insertAfter.nextElementSibling
        }

        clone.setAttribute('data-duplicate', 'true')
        insertAfter.insertAdjacentElement('afterend', clone)

        // max cloned
        if ((this._totalClones + 1) === this._variantIds.length) {
          this.setAttribute('data-max-cloned', 'true')
        }
      }, { signal: this._ac.signal })
    }

    this._onVariantChange()
  }

  unmount() {
    this.els = {}
  }

  /**
   *
   * @returns {void}
   */
  _onVariantChange() {
    const variantField = this.els.field_vid
    const qtyField = this.els.field_qty
    const prices = this.els.prices

    const selectedVariantId = variantField.value
    if (selectedVariantId) {
      const selectedOption = variantField.options[variantField.selectedIndex]
      let maxQty = +selectedOption.getAttribute('data-inv-qty')
      let invManagement = selectedOption.getAttribute('data-inv-management')
      if (invManagement != 'shopify') {
        maxQty = 20_000
      }

      qtyField.max = maxQty
      let qtyValue = qtyField.valueAsNumber || 0
      if (qtyValue > maxQty) {
        qtyValue = 0
        qtyField.value = 0
      }

      // update image
      const imgEl = this.els.featured_img
      const img = selectedOption.getAttribute('data-image') || this._featured_img_src || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081'
      if (imgEl && imgEl.src != img) {
        imgEl.setAttribute('src', img)
      }

      // update price
      const price = parseInt(selectedOption.getAttribute('data-price'))
      prices.current.textContent = theme.Currency.formatMoney(price, window.theme.moneyFormat)
      prices.current.removeAttribute('hidden')
      this._updateTotalPrice(price, qtyValue)

      const cp = parseInt(selectedOption.getAttribute('data-compare-at-price') || 0)
      if (Number.isInteger(cp) && cp > 0) {
        prices.compare.textContent = theme.Currency.formatMoney(cp, window.theme.moneyFormat)
      }
      prices.compare.toggleAttribute('hidden', cp < 1)
    } else {
      prices.current.textContent = ''
      prices.compare.textContent = ''
      prices.current.setAttribute('hidden', '')
      prices.compare.setAttribute('hidden', '')
      prices.total.setAttribute('hidden', '')
      this._updateTotalPrice(0, 0)
    }

    this._canAddToCart()
  }

  /**
   *
   * @param {HTMLInputElement} qtyField
   * @returns {void}
   */
  _onQuantityChange() {
    const qtyField = this.els.field_qty

    let value = Math.max(Math.floor(qtyField.valueAsNumber), 0)
    if (Number.isNaN(value)) {
      value = 0
    }
    qtyField.value = value

    const variantField = this.els.field_vid
    // console.log({ onlyOneVariant, count: variantField.childElementCount })
    const selectedOption = variantField.value
      ? variantField.options[variantField.selectedIndex]
      : null

    // update total
    const price = selectedOption ? parseInt(selectedOption.getAttribute('data-price')) : 0
    this._updateTotalPrice(price, value)

    this._canAddToCart()
  }

  _updateTotalPrice(price, qty) {
    // update total
    const totalPrice = price * qty

    const prices = this.els.prices
    prices.total.textContent =
      totalPrice > 0 ? theme.Currency.formatMoney(totalPrice, window.theme.moneyFormat) : ''
    prices.total.toggleAttribute('hidden', totalPrice < 1)
  }

  /**
   *
   * @param {HTMLElement} rowItem
   * @returns {boolean}
   */
  _canAddToCart() {
    const qtyField = this.els.field_qty
    const vidField = this.els.field_vid

    const maxQty = +qtyField.max || 0
    const currentQty = qtyField.valueAsNumber || 0
    const isQtyValid = currentQty > 0 && currentQty <= maxQty

    const isVariantIdValid = !!vidField.value
    const canAddToCart = isQtyValid && isVariantIdValid

    this.setAttribute('data-can-add-to-cart', canAddToCart ? 'true' : 'false')

    const onlyOneVariant = vidField.childElementCount === 1

    if (canAddToCart) {
      qtyField.setAttribute('name', qtyField.getAttribute('data-name'))
      vidField.setAttribute('name', vidField.getAttribute('data-name'))

      vidField.required = !onlyOneVariant
    } else {
      qtyField.removeAttribute('name')
      vidField.removeAttribute('name')
      vidField.required = false
    }

    return canAddToCart
  }

  _cacheElements() {
    const parent = this.closest('x-add-multiple-products')

    if (!parent) {
      this.setAttribute('data-invalid', 'true')
      return
    }
    this.els.addonParent = parent

    const inputs = this.querySelectorAll('[data-form-input]')
    for (let i = 0, l = inputs.length; i < l; i++) {
      const el = inputs[i]
      const name = el.getAttribute('data-form-input')
      if (name === 'variant.id') {
        this.els.field_vid = el
      } else if (name === 'variant.qty') {
        this.els.field_qty = el
      }
    }

    const img = this.querySelector('img[data-featured-img]')
    this.els.featured_img = img || null

    const priceEl = this.querySelector('.x-add-multiple-products__addon-row-item--product-price')
    this.els.prices.current = priceEl.querySelector('[data-price]')
    this.els.prices.compare = priceEl.querySelector('[data-compare-at-price]')
    this.els.prices.total = this.querySelector('[data-total-price]')

    this.els.duplicate_btn =
      this.getAttribute('data-duplicate') === 'true'
        ? null
        : this.querySelector('[data-duplicate-btn]') || null

    const allVariantOptions = this.els.field_vid.querySelectorAll('option[value][data-price]')
    for (let i = 0, l = allVariantOptions.length; i < l; i++) {
      const option = allVariantOptions[i]
      const variantId = option.value
      if (!variantId) continue

      let maxQty = +option.getAttribute('data-inv-qty')
      let invManagement = option.getAttribute('data-inv-management')
      if (invManagement != 'shopify' || Number.isNaN(maxQty)) {
        maxQty = 20_000
      }

      this._variantIds.push({
        id: +option.value,
        price: +option.getAttribute('data-price'),
        compare_at_price: +option.getAttribute('data-compare-at-price'),
        inventory_quantity: maxQty,
        inventory_policy: option.getAttribute('data-inv-policy'),
        inventory_management: invManagement,
        sku: option.getAttribute('data-sku'),
        image: option.getAttribute('data-image') || null,
      })
    }

    this._featured_img_src = this.getAttribute('data-featured-img-src') || ''
  }
}

if (!customElements.get('x-product-item')) {
  customElements.define('x-product-item', XProductItem)
}

// TODO: Check and adjust max-quantity on duplicate entries
